// /** @module maps/google */
import { GoogleMap } from "./map_google";
import { getUrl } from "../main_ptx";
import { MAP_TYPE_EDIT_GZ, MAP_TYPE_EDIT_POI } from "./map_base";

/**
 * @alias Ptx.maps.GoogleEdit
 */
export const GoogleMapEdit = GoogleMap.extend(
		/** @lends module:maps/google */
		{
			getTerraDrawLibs: function () {
				var TD = globalThis.terraDraw;
				var TDGoogle = globalThis.terraDrawGoogleMapsAdapter;

				if (!TD) {
					throw new Error("terraDraw is not loaded yet.");
				}

				if (!TDGoogle) {
					throw new Error("terraDrawGoogleMapsAdapter is not loaded yet.");
				}

				return {
					TerraDraw: TD.TerraDraw,
					TerraDrawPolygonMode: TD.TerraDrawPolygonMode,
					TerraDrawLineStringMode: TD.TerraDrawLineStringMode,
					TerraDrawCircleMode: TD.TerraDrawCircleMode,
					TerraDrawSelectMode: TD.TerraDrawSelectMode,
					TerraDrawGoogleMapsAdapter: TDGoogle.TerraDrawGoogleMapsAdapter || TDGoogle
				};
			},

			startTerraDrawWhenGoogleMapReady: function () {
				var self = this;
				var triesLeft = 100;

				function hasGoogleMapEventLayer() {
					if (!self.map || !self.map.getDiv) return false;

					var mapDiv = self.map.getDiv();
					if (!mapDiv) return false;

					var eventLayer = mapDiv.querySelector('div[style*="z-index: 3;"]');
					return !!eventLayer;
				}

				function tryStart() {
					if (hasGoogleMapEventLayer()) {
						self.terraDraw.start();
						self.terraDrawStarted = true;

						if (self.pendingTerraFeatures) {
							var pending = self.pendingTerraFeatures;
							self.pendingTerraFeatures = null;

							self.terraDraw.clear();

							var result = self.terraDraw.addFeatures(pending);
							console.log("Terra Draw pending addFeatures result:", result, pending);

							self.updateBoundsFromFeature(pending[0]);
							self.setMapMode('edit');
							self.shapeChanged();

							return;
						}

						if (self.editTool) {
							self.terraDraw.setMode(self.editTool);
						}

						return;
					}

					triesLeft--;

					if (triesLeft <= 0) {
						throw new Error("Terra Draw could not start because the Google Maps event layer was not ready.");
					}

					setTimeout(tryStart, 50);
				}

				tryStart();
			},

			addOrQueueTerraFeature: function (feature) {
				if (!feature) return;

				if (!this.terraDraw || !this.terraDrawStarted) {
					this.pendingTerraFeatures = [feature];
					return;
				}

				this.suppressShapeChanged = true;

				this.terraDraw.clear();
				var result = this.terraDraw.addFeatures([feature]);

				this.suppressShapeChanged = false;

				var result = this.terraDraw.addFeatures([feature]);
				console.log("Terra Draw addFeatures result:", result, feature);

				this.updateBoundsFromFeature(feature);
				this.setMapMode('edit');
				this.shapeChanged();
			},

			createTerraDrawCircleFeature: function (center, radiusMeters) {
				function roundCoord(num) {
					return Math.round(Number(num) * 1000000) / 1000000;
				}

				var ring = [];
				var steps = 64;
				var lat = roundCoord(center[1]);
				var lon = roundCoord(center[0]);
				var radiusKm = Number(radiusMeters || 0) / 1000;

				// Approximate earth radius in km
				var earthRadiusKm = 6371;
				var angularDistance = radiusKm / earthRadiusKm;

				var latRad = lat * Math.PI / 180;
				var lonRad = lon * Math.PI / 180;

				for (var i = 0; i <= steps; i++) {
					var bearing = 2 * Math.PI * i / steps;

					var pointLatRad = Math.asin(
							Math.sin(latRad) * Math.cos(angularDistance) +
							Math.cos(latRad) * Math.sin(angularDistance) * Math.cos(bearing)
					);

					var pointLonRad = lonRad + Math.atan2(
							Math.sin(bearing) * Math.sin(angularDistance) * Math.cos(latRad),
							Math.cos(angularDistance) - Math.sin(latRad) * Math.sin(pointLatRad)
					);

					ring.push([
						roundCoord(pointLonRad * 180 / Math.PI),
						roundCoord(pointLatRad * 180 / Math.PI)
					]);
				}

				return {
					type: "Feature",
					properties: {
						mode: "circle",
						center: [lon, lat],
						radius: Number(radiusMeters || 0),
						radiusKilometers: radiusKm
					},
					geometry: {
						type: "Polygon",
						coordinates: [ring]
					}
				};
			},

			editClusterOpts: {
				'general': { gridSize: 50, maxZoom: 15 },
				'vehicle': { gridSize: 50, maxZoom: 12 },
				'tp': {
					gridSize: 50,
					maxZoom: 14,
					styles: [{
						url: getUrl('/img/tp-cluster.png'),
						width: 53,
						height: 52,
						textColor: '#ff00ff',
						textSize: 0.1
					}, {
						url: getUrl('/img/tp-cluster.png'),
						width: 53,
						height: 52,
						textColor: '#ff0000',
						textSize: 0.1
					}, {
						url: getUrl('/img/tp-cluster.png'),
						width: 53,
						height: 52,
						textColor: '#0000ff',
						textSize: 0.1
					}]
				}
			},

			terraDraw: null,
			terraDrawStarted: false,
			terraDrawChanging: false,
			suppressShapeChanged: false,
			pendingTerraFeatures: null,
			buffer: null,
			editTool: null,
			lastChangeTimer: null,

			constructor: function (mapContainer, opts, mapSettings) {
				this.name = "GM_E";
				this.clusterOpts[MAP_TYPE_EDIT_GZ] = this.editClusterOpts;
				this.clusterOpts[MAP_TYPE_EDIT_POI] = this.editClusterOpts;

				// No Google drawing library needed anymore.
				// Keep geometry if other parts of GoogleMap still need it.
				opts['libraries'] = 'geometry';

				this.base(mapContainer, opts, mapSettings);
			},

			internalMapInit: function (self) {
			},

			findMapCreatorFunction_: function () {
				var mt = this.opts.mapType;

				if (mt === MAP_TYPE_EDIT_GZ || mt === MAP_TYPE_EDIT_POI) {
					this.prepareEditGeozonePOIMap(mt === MAP_TYPE_EDIT_POI);
				} else {
					return this.base();
				}
			},

			gjDataShow: function (geoJsonData, afterLoadCallback) {
				var mt = this.opts.mapType;

				if (mt !== MAP_TYPE_EDIT_GZ && mt !== MAP_TYPE_EDIT_POI) {
					return this.base();
				}

				this.removeEditShapes();

				var feature = this.getFeature_(geoJsonData);
				this.geoJson = feature;

				var tdFeature = this.convertLegacyFeatureToTerraFeature(feature);

				if (tdFeature) {
					this.addOrQueueTerraFeature(tdFeature);
				}

				this.gjDataShowBounds();

				if (typeof afterLoadCallback === 'function') {
					afterLoadCallback();
				}
			},

			getFeature_: function (gj) {
				function getType(t) {
					if (t === "LineString") return "POLYLINE";
					return t.toUpperCase();
				}

				if (gj.type && gj.type === 'Feature') return gj;

				var geomType = getType(gj.type);

				var f = {
					type: 'Feature',
					properties: {
						gzType: geomType,
						radius: 0
					},
					geometry: {
						type: 'GeometryCollection',
						geometries: []
					}
				};

				var cs = gj.coordinates;
				var gs = f.geometry.geometries;

				for (var i = 0; i < cs.length; i++) {
					gs.push({ type: 'Point', coordinates: cs[i] });
				}

				f.geometry.geometries.push(gj);
				return f;
			},

			convertLegacyFeatureToTerraFeature: function (feature) {
				var type = feature.properties.gzType;
				var radius = Number(feature.properties.radius || 0);
				var gCollection = feature.geometry.geometries || [];
				var points = [];

				for (var i = 0; i < gCollection.length; i++) {
					if (gCollection[i].type === "Point") {
						points.push(gCollection[i].coordinates);
					}
				}

				if (type === "POLYGON") {
					if (points.length === 0) return null;

					var ring = points.slice();

					if (
							ring.length > 0 &&
							(ring[0][0] !== ring[ring.length - 1][0] ||
									ring[0][1] !== ring[ring.length - 1][1])
					) {
						ring.push([ring[0][0], ring[0][1]]);
					}

					return {
						type: "Feature",
						properties: {
							mode: "polygon"
						},
						geometry: {
							type: "Polygon",
							coordinates: [ring]
						}
					};
				}

				if (type === "POLYLINE") {
					return {
						type: "Feature",
						properties: {
							mode: "linestring"
						},
						geometry: {
							type: "LineString",
							coordinates: points
						}
					};
				}

				if (type === "POINT") {
					if (points.length === 0) return null;

					return this.createTerraDrawCircleFeature(points[0], radius);
				}

				return null;
			},

			removeEditShapes: function () {
				if (this.terraDraw && this.terraDrawStarted) {
					this.terraDraw.clear();
				}

				this.removeRealShape();
			},

			hasSomeOverlays: function () {
				return this.terraDraw &&
						this.terraDrawStarted &&
						this.terraDraw.getSnapshot().length > 0;
			},

			prepareEditGeozonePOIMap: function (editPOI) {
				var libs = this.getTerraDrawLibs();

				var TerraDraw = libs.TerraDraw;
				var TerraDrawPolygonMode = libs.TerraDrawPolygonMode;
				var TerraDrawLineStringMode = libs.TerraDrawLineStringMode;
				var TerraDrawCircleMode = libs.TerraDrawCircleMode;
				var TerraDrawSelectMode = libs.TerraDrawSelectMode;
				var TerraDrawGoogleMapsAdapter = libs.TerraDrawGoogleMapsAdapter;

				var modes = [
					new TerraDrawSelectMode({
						flags: {
							polygon: {
								feature: {
									draggable: true,
									coordinates: {
										draggable: true,
										deletable: true
									}
								}
							},
							linestring: {
								feature: {
									draggable: true,
									coordinates: {
										draggable: true,
										deletable: true
									}
								}
							},
							circle: {
								feature: {
									draggable: true,
									coordinates: {
										draggable: false,
										deletable: false,
										midpoints: false
									}
								}
							}
						}
					}),
					new TerraDrawCircleMode()
				];

				if (!editPOI) {
					modes.push(
							new TerraDrawPolygonMode(),
							new TerraDrawLineStringMode()
					);
				}

				this.terraDraw = new TerraDraw({
					adapter: new TerraDrawGoogleMapsAdapter({
						map: this.map,
						lib: google.maps
					}),
					modes: modes
				});

				var self = this;

				this.terraDraw.on("finish", function (id, context) {
					if (context && context.action === "draw") {
						self.keepOnlyNewestFeature();
						self.setMapMode("edit");
					}

					self.shapeChanged();
				});

				this.terraDraw.on("change", function (ids, type, context) {
					if (self.suppressShapeChanged) return;
					if (context && context.origin === "api") return;

					self.debouncedShapeChanged();
				});

				this.startTerraDrawWhenGoogleMapReady();
			},

			keepOnlyNewestFeature: function () {
				if (!this.terraDraw) return;

				var features = this.terraDraw.getSnapshot();

				if (features.length <= 1) return;

				var last = features[features.length - 1];

				this.terraDraw.clear();
				this.terraDraw.addFeatures([last]);
			},

			debouncedShapeChanged: function () {
				var self = this;

				if (this.lastChangeTimer) {
					clearTimeout(this.lastChangeTimer);
				}

				this.lastChangeTimer = setTimeout(function () {
					self.shapeChanged();
				}, 150);
			},

			setEditTool: function (type) {
				var mode = null;

				if (type === "POINT") {
					mode = "circle";
				} else if (type === "POLYLINE") {
					mode = "linestring";
				} else if (type === "POLYGON") {
					mode = "polygon";
				}

				this.editTool = mode;

				if (mode && this.terraDraw && this.terraDrawStarted) {
					this.terraDraw.setMode(mode);
				}
			},

			setMapMode: function (mode) {
				if (!this.terraDraw || !this.terraDrawStarted) return;

				if (mode === 'edit') {
					this.terraDraw.setMode('select');
				} else if (this.editTool) {
					this.terraDraw.setMode(this.editTool);
				}
			},

			propagateInfo: function (obj) {
				function r_num(num, dec) {
					return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
				}

				if (obj.updateRadius === true) {
					$(this.opts.radiusInput).val(Math.round(Number(obj.radius)));
				}

				if (obj.fromMap === true) {
					if (obj.lat && obj.lon) {
						var lat = r_num(Number(obj.lat), 6);
						var lon = r_num(Number(obj.lon), 6);

						$(this.opts.latInput).val(lat);
						$(this.opts.lonInput).val(lon);
					}
				}
			},

			shapeChanged: function () {
				var gjOut = $(this.opts.geoJsonOutput);

				if (gjOut === null || gjOut === '') return;

				var rad = $(this.opts.radiusInput);
				var radius = rad.val();

				var gj = this.dumpGeoJSON();

				if (!gj) return;
				if (!this.isGeoJSONValid(gj)) return;

				gjOut.val(JSON.stringify(gj, null, ''));

				var circle = this.getCurrentCircleFeature();

				if (circle) {
					var coords = this.getPolygonCenter(circle);

					this.propagateInfo({
						radius: radius || 0,   // keep custom field value
						lat: coords[1],
						lon: coords[0],
						fromMap: true
					});
				}

				if (circle) {
					// Circle itself is the editable point/POI shape.
					// Do not draw buffer polygon over it while dragging.
					this.removeRealShape();
					return;
				}

				if (radius !== '') {
					if (radius !== '0') {
						this.drawRealShape(gj, radius);
					} else {
						this.removeRealShape();
					}
				} else {
					rad.val('0');
					this.removeRealShape();
				}
			},

			removeRealShape: function () {
				if (this.buffer) {
					this.buffer.setMap(null);
					this.buffer = null;
				}
			},

			drawRealShape: function (geoJSON, radius) {
				if (geoJSON.type === 'Point') return;

				var gjStr = JSON.stringify(geoJSON, null, '');
				var self = this;

				this.removeRealShape();

				Ptx.fn.openPtx('/settings/geozones/geozones/buffer.json', "POST", {
					polyJson: gjStr,
					radius: radius
				}, function (data, svr) {
					var gj = JSON.parse(data);

					if (self.buffer) {
						self.buffer.setMap(null);
						self.buffer = null;
					}

					var ovl = self.createGooglePolygonFromCoords(
							gj.coordinates[0][0],
							{
								strokeColor: 'red',
								fillOpacity: 0.15,
								fillColor: 'red',
								zIndex: -1
							}
					);

					ovl.setMap(self.map);
					self.buffer = ovl;
				});
			},

			createGooglePolygonFromCoords: function (coords, opts) {
				var polygon = [];

				for (var i = 0; i < coords.length; i++) {
					var ll = new google.maps.LatLng(coords[i][1], coords[i][0]);
					polygon.push(ll);
				}

				var p = new google.maps.Polygon({
					paths: polygon,
					editable: false
				});

				if (typeof opts !== 'undefined') {
					p.setOptions(opts);
				}

				return p;
			},

			getPolygonCenter: function (feature) {
				var ring = feature.geometry.coordinates[0];
				var lon = 0;
				var lat = 0;

				for (var i = 0; i < ring.length; i++) {
					lon += Number(ring[i][0]);
					lat += Number(ring[i][1]);
				}

				return [
					lon / ring.length,
					lat / ring.length
				];
			},

			convertCircleToBackendPointGeoJSON: function (feature) {
				var center = this.getPolygonCenter(feature);

				return {
					type: "Point",
					coordinates: [[
						Number(center[0]),
						Number(center[1])
					]]
				};
			},

			dumpGeoJSON: function () {
				if (!this.terraDraw || !this.terraDrawStarted) return null;

				var features = this.terraDraw.getSnapshot();

				if (!features || features.length === 0) return null;

				var feature = features[0];

				if (feature.properties && feature.properties.mode === "circle") {
					return this.convertCircleToBackendPointGeoJSON(feature);
				}

				if (feature.geometry.type === "LineString") {
					return this.convertLineStringToGeoJSON([feature]);
				}

				if (feature.geometry.type === "Polygon") {
					return this.convertPolygonToGeoJSON([feature]);
				}

				return this.convertPointToGeoJSON([feature]);
			},

			convertPointToGeoJSON: function (features) {
				var coordinates = [];

				for (var i = 0; i < features.length; i++) {
					if (features[i].geometry.type === "Point") {
						coordinates.push(features[i].geometry.coordinates);
					}
				}

				return {
					type: 'Point',
					coordinates: coordinates
				};
			},

			convertPolygonToGeoJSON: function (features) {
				var coordinates = [];

				for (var i = 0; i < features.length; i++) {
					if (features[i].geometry.type !== "Polygon") continue;

					var ring = features[i].geometry.coordinates[0];

					for (var j = 0; j < ring.length; j++) {
						coordinates.push(ring[j]);
					}
				}

				return {
					type: 'Polygon',
					coordinates: coordinates
				};
			},

			convertLineStringToGeoJSON: function (features) {
				var coordinates = [];

				for (var i = 0; i < features.length; i++) {
					if (features[i].geometry.type !== "LineString") continue;

					var line = features[i].geometry.coordinates;

					for (var j = 0; j < line.length; j++) {
						coordinates.push(line[j]);
					}
				}

				return {
					type: 'LineString',
					coordinates: coordinates
				};
			},

			getCurrentCircleFeature: function () {
				if (!this.terraDraw || !this.terraDrawStarted) return null;

				var features = this.terraDraw.getSnapshot();

				for (var i = 0; i < features.length; i++) {
					if (features[i].properties && features[i].properties.mode === "circle") {
						return features[i];
					}
				}

				return null;
			},

			getCircleRadius: function (feature) {
				if (!feature || !feature.properties) return 0;

				if (typeof feature.properties.radius !== "undefined") {
					return Number(feature.properties.radius);
				}

				if (typeof feature.properties.radiusKilometers !== "undefined") {
					return Number(feature.properties.radiusKilometers) * 1000;
				}

				return 0;
			},

			showPOI: function (lat, lon, radius, callback) {
				this.removeEditShapes();

				var itemWasDrawn = true;

				if (
						lat && lat !== '' &&
						lon && lon !== '' &&
						radius && radius !== '' &&
						Number(radius) > 0
				) {
					var feature = {
						type: "Feature",
						properties: {
							mode: "circle",
							radius: Number(radius)
						},
						geometry: {
							type: "Point",
							coordinates: [Number(lon), Number(lat)]
						}
					};

					this.terraDraw.addFeatures([feature]);
					this.setMapMode('edit');
					this.shapeChanged();
				} else {
					itemWasDrawn = false;
					this.setEditTool('POINT');
					this.setMapMode('draw');
				}

				if (callback) callback();

				return itemWasDrawn;
			},

			updatePoint: function () {
				function r_num(num, dec) {
					return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
				}

				if (!this.terraDraw) return;

				var features = this.terraDraw.getSnapshot();
				var circle = this.getCurrentCircleFeature();

				if (!circle) return;

				var sRad = $(this.opts.radiusInput).val();
				var sLat = $(this.opts.latInput).val();
				var sLon = $(this.opts.lonInput).val();

				if (sRad !== '') {
					circle.properties.radius = Number(sRad);
				}

				if (sLat !== '' && sLon !== '') {
					circle.geometry.coordinates = [
						r_num(Number(sLon), 6),
						r_num(Number(sLat), 6)
					];
				}

				this.terraDraw.clear();
				this.terraDraw.addFeatures([circle]);

				var center = new google.maps.LatLng(
						circle.geometry.coordinates[1],
						circle.geometry.coordinates[0]
				);

				var bounds = new google.maps.Circle({
					center: center,
					radius: Number(circle.properties.radius || 0)
				}).getBounds();

				this.map.fitBounds(bounds);

				this.setMapMode('edit');
				this.shapeChanged();
			},

			updateBoundsFromFeature: function (feature) {
				this.geoBounds = new google.maps.LatLngBounds();

				if (!feature || !feature.geometry) return;

				var type = feature.geometry.type;

				if (type === "Point") {
					var c = feature.geometry.coordinates;
					this.geoBounds.extend(new google.maps.LatLng(c[1], c[0]));
					return;
				}

				if (type === "LineString") {
					for (var i = 0; i < feature.geometry.coordinates.length; i++) {
						var p = feature.geometry.coordinates[i];
						this.geoBounds.extend(new google.maps.LatLng(p[1], p[0]));
					}
					return;
				}

				if (type === "Polygon") {
					var ring = feature.geometry.coordinates[0];

					for (var j = 0; j < ring.length; j++) {
						var pp = ring[j];
						this.geoBounds.extend(new google.maps.LatLng(pp[1], pp[0]));
					}
				}
			}
		}
);